
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightRain as ObiLightningLightRainElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-rain.js';
 
 
 

 
 export const ObiLightningLightRain = createComponent({
   react: React,
   tagName: 'obi-lightning-light-rain',
   elementClass: ObiLightningLightRainElement,
   events: {
     
   }
  });
 
 